import { Label } from "@fluentui/react-components";
import { BaseNoDataWrapper } from "./Styles";
import { useTranslation } from "react-i18next";

const Nodata = () => {
  const { t } = useTranslation();
  return (
    <BaseNoDataWrapper className="BaseNoDataWrapper">
      <Label className="custom-text">{t("No data available")}</Label>
      <span></span>
    </BaseNoDataWrapper>
  );
};

export default Nodata;
